module.exports = __webpack_public_path__ + "static/media/negativeImpactDetailTitle.5d8d5ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/negativeImpactDetailTitle.png
// module id = 902
// module chunks = 0